import dayjs from 'utils/dayjs';
import { RATEPLAN_UPDATE_STATUS, RECOMMENDATION_VERSION } from 'right-revenue-microservice-sdk/lib/constants';
import { get } from 'lodash';

const SELLING_RATE_CATEGORY = {
    NO_RATE: 'NO_RATE', // no rate for date in question
    PAST: 'PAST', // there is a rate but the date is in the past
    PENDING_UPDATE: 'PENDING_UPDATE',
    FAILED_UPDATE: 'FAILED_UPDATE', // whether retryable or not
    RECOMMENDATION: 'RECOMMENDATION', // no pending update, recommendation(s) available
    NO_ACTION: 'NO_ACTION', // none of the above. Rate can be manually overwritten if desired
};

const DEFAULT_CELL_COLOURS = {
    0: 'rgb(10, 200, 10)', // defaulting to green so its equivalent to low
    1: 'rgb(10, 200, 10)', // lowest priority - green
    2: 'rgb(247, 146, 0)', // medium priority - amber
    3: 'rgb(255, 55, 55)', // highest priority - red
};

/**
 * Identify which "category" of selling rate it is depending on its object
 * @param {Object} rate
 * @return {SELLING_RATE_CATEGORY}
 */
const identifySellingRateCategory = (rate, viewAERecs = true) => {
    if (!rate) return SELLING_RATE_CATEGORY.NO_RATE;

    if (dayjs(rate.stayDate).isBefore(dayjs(), 'day')) {
        return SELLING_RATE_CATEGORY.PAST; // No actions shown in the past;
    }

    // Any ongoing update takes precedence over everything else
    switch (get(rate, 'pmsUpdateStatus.status')) {
        case RATEPLAN_UPDATE_STATUS.FINAL_ERROR:
        case RATEPLAN_UPDATE_STATUS.RETRYABLE_ERROR:
            return SELLING_RATE_CATEGORY.FAILED_UPDATE;
        case RATEPLAN_UPDATE_STATUS.PENDING:
            return SELLING_RATE_CATEGORY.PENDING_UPDATE;
        default:
            // If undefined or other status
            // No other status (e.g. success) should ever be returned by the API, so ignore
            break;
    }

    if (get(rate, 'pendingUpdate', []).length > 0) {
        return SELLING_RATE_CATEGORY.PENDING_UPDATE;
    }

    if (get(rate, 'availableRecommendations', []).length > 0) {
        if (!viewAERecs) {
            if (
                rate.availableRecommendations.filter(({ version }) => version === RECOMMENDATION_VERSION.CARDINAL)
                    .length === 0
            ) {
                return SELLING_RATE_CATEGORY.NO_ACTION;
            }
        }
        return SELLING_RATE_CATEGORY.RECOMMENDATION;
    }

    return SELLING_RATE_CATEGORY.NO_ACTION;
};

const workoutChannelManagerStatus = (rate) => {
    switch (get(rate, 'channelManagerUpdateStatus.status')) {
        case RATEPLAN_UPDATE_STATUS.FINAL_ERROR:
        case RATEPLAN_UPDATE_STATUS.RETRYABLE_ERROR:
            return SELLING_RATE_CATEGORY.FAILED_UPDATE;
        case RATEPLAN_UPDATE_STATUS.PENDING:
            return SELLING_RATE_CATEGORY.PENDING_UPDATE;
        default:
            // If undefined or other status
            // No other status (e.g. success) should ever be returned by the API, so ignore
            break;
    }
    return null;
};

const getCellBackgroundColour = (priority) => {
    const defaultCellColourForPriority = DEFAULT_CELL_COLOURS[priority] || DEFAULT_CELL_COLOURS[0];

    return defaultCellColourForPriority;
};

export { SELLING_RATE_CATEGORY, getCellBackgroundColour, identifySellingRateCategory, workoutChannelManagerStatus };
